var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',[_c('h1',[_vm._v("Settings")]),_c('h1',[_vm._v("WORK IN PROGRESS!")])])],1),_c('v-row',[_c('v-col',[_c('h2',[_vm._v("DLCs")])])],1),_c('v-row',[_c('v-col',[_c('select-dlcs')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }